import { LOAD_MODEL } from "../constans";

export const loadModelAction = (result) => ({
  type: LOAD_MODEL,
  payload: result,
});
